import '../../style/index.less';
import './index.less';
import 'mkui-ext/lib/currency-input/style';